import React from 'react';
import { Button, StapleTableCell, StapleTableRow, Tooltip } from '@insurancemenu/imenu-components-lib';
import { Download } from '@insurancemenu/imenu-components-lib/dist/icons';
import { AlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { FileNameStyled, StapleTableCellStyled } from './styles';

interface Props {
  name: string;
  indexNumber: number;
  onDownload: () => void;
}

const DownloadFileTableRow: React.FC<Props> = ({ name, indexNumber, onDownload }) => {
  return (
    <StapleTableRow>
      <StapleTableCell onClick={onDownload} width="30rem">
        <b>{`${indexNumber}. `}</b>
        <FileNameStyled>{name}</FileNameStyled>
      </StapleTableCell>
      <StapleTableCellStyled width="15rem">
        <Tooltip alignment={AlignmentTypes.LEFT_CENTER} label="Download File">
          <Button type="icon" color="primary" onClick={onDownload}>
            <Download width="2.4rem" height="2.4rem" />
          </Button>
        </Tooltip>
      </StapleTableCellStyled>
    </StapleTableRow>
  );
};

export default DownloadFileTableRow;
